import { render, staticRenderFns } from "./date-picker.editor.vue?vue&type=template&id=fab8c142&"
import script from "./date-picker.editor.vue?vue&type=script&lang=ts&"
export * from "./date-picker.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports